import _styled from "styled-components";
const _excluded = ["className", "style", "selectedItems", "getSelectedItemProps", "removeSelectedItem", "itemToString"],
  _excluded2 = ["style", "css"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';
import Token from './Token';
const TokensWrapped = (_ref, ref) => {
  let {
      className,
      style,
      selectedItems,
      getSelectedItemProps,
      removeSelectedItem,
      itemToString
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    ref: ref,
    className: className
  }, props, {
    $_css: [{
      display: 'flex',
      flexWrap: 'wrap',
      flex: 1,
      overflowY: 'auto',
      maxHeight: 'inherit'
    }, style]
  }), selectedItems.map((selectedItem, index) => {
    const _getSelectedItemProps = getSelectedItemProps({
        selectedItem,
        index
      }),
      {
        style: tokenStyle,
        css: _ignored
      } = _getSelectedItemProps,
      selectedItemProps = _objectWithoutProperties(_getSelectedItemProps, _excluded2);
    return /*#__PURE__*/React.createElement(Token, _extends({
      key: "selected-item-".concat(index),
      style: tokenStyle,
      onClickX: () => removeSelectedItem(selectedItem)
    }, selectedItemProps, {
      content: itemToString(selectedItem)
    }));
  }));
};
const Tokens = /*#__PURE__*/React.forwardRef(TokensWrapped);
Tokens.displayName = 'Tokens';
Tokens.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Array of selected items to represent with Tokens */
  selectedItems: PropTypes.array.isRequired,
  /** Function that returns props which will be applied to each Token */
  getSelectedItemProps: PropTypes.func.isRequired,
  /** Function executed upon clicking the X icon of a Token */
  removeSelectedItem: PropTypes.func.isRequired,
  /** Function which converts an item to its string representation */
  itemToString: PropTypes.func.isRequired
};
export default Tokens;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Tokens___StyledDiv",
  componentId: "sc-17f6jke-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Tokens.js.map